import LoginView from '@/views/Login.vue'

const authRoutes = [{ path: '/login', name: 'Login', component: LoginView }]

export default authRoutes
